var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5046_71568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0362 15.56L22.7873 13.3761C22.7873 13.3761 19.4548 14.0534 14.8364 14.0534C14.5045 14.0534 14.2694 14.0534 13.7163 14.0534V16.2649V18.2829H15.3756V16.2925C15.832 16.2925 16.2468 16.2925 16.6616 16.2787V18.2414L18.3071 18.1723V16.1543C20.8376 16.0299 23.0362 15.56 23.0362 15.56Z",
    fill: "#45B035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8087 12.7956C18.321 12.7956 21.0727 12.2289 21.0727 12.2289L20.8376 10.3353C20.8376 10.3353 17.92 10.8882 14.6566 10.8882C14.3247 10.8882 14.1865 10.8882 13.7163 10.8882V12.7956C14.2418 12.7956 14.4907 12.7956 14.8087 12.7956Z",
    fill: "#FDD000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6982 9.50595C16.8969 9.50595 18.2796 9.14658 18.2796 9.14658L18.0722 7.47412C18.0722 7.47412 16.7309 7.81967 14.6844 7.81967C14.3525 7.81967 14.159 7.81967 13.7026 7.81967V9.49213C13.993 9.50595 14.3664 9.50595 14.6982 9.50595Z",
    fill: "#EB6100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3896 6.21634L15.2513 5C15.2513 5 14.5185 5.13822 13.7026 5.13822V6.36838C14.7121 6.36838 15.3896 6.21634 15.3896 6.21634Z",
    fill: "#C7000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8823 10.8882H9.63721V12.7956H13.8823V10.8882Z",
    fill: "#005BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7025 5.13818H10.8125V6.36834H13.7025V5.13818Z",
    fill: "#F39800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7026 7.8197H9.45752V9.49216H13.7026V7.8197Z",
    fill: "#2990D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7166 16.2511V14.0396H7.79834V18.0203C8.36528 18.0617 8.75246 18.0756 9.48533 18.1309V16.2511H10.7713V18.1861C11.3244 18.2276 11.8084 18.2276 12.4168 18.2414V16.2511H13.7166Z",
    fill: "#0D045F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7096 17.4674C24.7096 17.4674 20.423 18.2553 13.9931 18.2553C7.49403 18.2553 3.29038 17.4674 3.29038 17.4674L3 20.0245C3 20.0245 6.84412 20.84 14.0069 20.84C20.2018 20.84 25 20.0245 25 20.0245L24.7096 17.4674Z",
    fill: "url(#paint0_radial_5046_71568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22119 13.307C3.22119 13.307 5.50278 13.0443 7.89498 11.3442L8.94589 12.602C8.94589 12.602 7.07914 14.4542 4.3689 15.1176L3.22119 13.307Z",
    fill: "#ABCD03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68701 8.08225C4.68701 8.08225 7.17601 7.18382 8.82152 5.38696L10.0384 6.40979C10.0384 6.40979 8.66941 8.4278 6.08362 9.61649L4.68701 8.08225Z",
    fill: "#FDD000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5046_71568",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.67882 18.8538) scale(17.5386 17.5312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1573,
    stopColor: "#E95D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9719,
    stopColor: "#6A006F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5046_71568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15.84,
    fill: "white",
    transform: "translate(3 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIk);
export default __webpack_public_path__ + "static/media/ik.ea18b72ca4bcf2a44d46448ec8c8f557.svg";
export { ForwardRef as ReactComponent };